
export const SET_EMAIL = "SET_EMAIL";
export const SET_PASSWORD = "SET_PASSWORD";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";

export const SUCCESS = "SUCCESS";
export const ERROR = "ERROR";
export const PENDING = "PENDING";

export const SET_USER = "SET_USER"; 
